(() => {
 if (window.__sparkPushPlay) return;
 window.__sparkPushPlay = true;
 const observers = new Map();
 function nodes(root) { return [...(root.matches?.('[data-spark-push-play]') ? [root] : []), ...root.querySelectorAll('[data-spark-push-play]')]; }
 function initialize(root) {
  nodes(root).forEach(section => {
   if (section.dataset.pushInitialized) return;
   section.dataset.pushInitialized = 'true';
   if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
   section.classList.add('is-pending');
   const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    section.classList.replace('is-pending', 'is-revealed');
    observer.disconnect(); observers.delete(section);
   }, { threshold: .25 });
   observers.set(section, observer); observer.observe(section);
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
 else initialize(document);
 document.addEventListener('shopify:section:load', e => initialize(e.target));
 document.addEventListener('shopify:section:unload', e => nodes(e.target).forEach(s => { observers.get(s)?.disconnect(); observers.delete(s); delete s.dataset.pushInitialized; s.classList.remove('is-pending','is-revealed'); }));
})();
